import { SnackbarProvider } from 'notistack'
import { ContextProviders } from '../contexts'
import {ThemeProvider} from './ThemeProvider'
import { PropsWithChildren } from 'react'

export const Providers = ({children}: PropsWithChildren) => {
    return (
        <SnackbarProvider>
            <ThemeProvider>
                <ContextProviders>
                    {children}
                </ContextProviders>
            </ThemeProvider>
        </SnackbarProvider>
    )
}